export default "__VITE_ASSET__C$_bcOKl__"